import { PayloadAction } from '@reduxjs/toolkit';

import { Addon, AddonsState } from 'editor/src/store/editorModules/addons/types';

const setAddonsInUseReducer = (state: AddonsState, action: PayloadAction<Addon[]>) => {
  state.inUse = action.payload;
};

export default setAddonsInUseReducer;
